<div class="promo-ed-cont p-2">
    <div class="d-flex justify-content-between align-items-center">
        <span class="promo-title">{{ "PROMOTION_EDITOR_COMPONENT_TITLE" | translate }}</span>
        <button class="promo-delete" (click)="onPromoDelete()">
            <img src="assets/img/ic_close.svg" class="delete-img" />
        </button>
    </div>
    <form class="w-100 mt-3">
        <input
            id="promo-name"
            class="w-100 px-2 mb-2"
            name="promo-name"
            placeholder="{{ 'PROMOTION_EDITOR_COMPONENT_NAME_PLACEHOLDER' | translate }}"
            [(ngModel)]="promoName"
        />
        <textarea
            id="promo-desc"
            class="w-100 px-2 mb-2"
            name="promo-desc"
            rows="3"
            placeholder="{{ 'PROMOTION_EDITOR_COMPONENT_DESC_PLACEHOLDER' | translate }}"
            [(ngModel)]="promoDesc"
        >
        </textarea>
        <ng-multiselect-dropdown
            [placeholder]="'PROMOTION_EDITOR_COMPONENT_PROD_PLACEHOLDER' | translate"
            [data]="products"
            [(ngModel)]="selectedItems"
            [settings]="dropdownSettings"
            (onSelect)="onItemSelect($event)"
            (onSelectAll)="onSelectAll($event)"
            name="promo-prods"
        >
        </ng-multiselect-dropdown>
    </form>
    <div class="d-flex justify-content-center mt-3">
        <button
            class="btn w-75 green-btn"
            [disabled]="!promoName || !promoDesc || promoName.length === 0 || promoDesc.length === 0"
            (click)="onPromoSave()"
        >
            {{ "PROMOTION_EDITOR_COMPONENT_SAVE" | translate }}
        </button>
    </div>
</div>
